import { render, staticRenderFns } from "./FormStoragePage.vue?vue&type=template&id=0c1e9213&scoped=true&"
import script from "./FormStoragePage.vue?vue&type=script&lang=js&"
export * from "./FormStoragePage.vue?vue&type=script&lang=js&"
import style0 from "./FormStoragePage.vue?vue&type=style&index=0&id=0c1e9213&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1e9213",
  null
  
)

export default component.exports